export const services = {
  headers: {
    requestedService: "Angeforderter Service",
  },
  actions: {
    discardRequest: "Anfrage verwerfen",
  },
  storeInactiveTitle: "Der Service-Shop ist nicht aktiv",
  storeInactiveDesc1:
    "Um Anfragen für Erlebnisse und Zusatzservices zu erhalten, müssen Sie Ihren Shop aktivieren.",
  storeInactiveDesc2:
    "Nach der Aktivierung können Ihre Gäste Services direkt über WhatsApp anfragen.",
  activateStoreBtn: "Service-Shop aktivieren",

  noServicesDesc1:
    "Aktivieren Sie Erlebnisse, indem Sie Ihre Zusatzservices einrichten: Frühstück, Touren, Transfers oder was immer Sie anbieten.",
  noServicesDesc2:
    "Ihre Gäste sehen sie gleich nach dem Check-in, direkt in WhatsApp.",
  addFirstServiceBtn: "Erstes Erlebnis oder Service hinzufügen",
};
